import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import { LanguageContext } from "../LanguageContext";
import logoImage from "../assets/logo.png";
const Header = () => {
  const navigate = useNavigate();
  const { language, toggleLanguage } = useContext(LanguageContext);

  return (
    <header className="header-container">
      <div className="header-logo" onClick={() => navigate("/")}>
         <img src={logoImage}/>
      </div>
      <div className="header-nav">
        <span onClick={toggleLanguage} style={{ cursor: "pointer" }}>
          {language === "ko" ? "KOR / ENG" : "ENG / KOR"}
        </span>
      </div>
    </header>
  );
};

export default Header;
